export default function () {
  return [
    {
      title: '组织层级',
      [$field]: 'allName',
      colSpan: 16,
      rules: ['']
    },
    {
      type: 'Input',
      title: '工会组织全称',
      [$field]: 'orgName',
      rules: ['']
    },
    {
      type: 'Input',
      title: '工会组织简称',
      [$field]: 'shortName',
      rules: ['']
    },
    {
      type: 'Input',
      title: '工会（分工会）主席（负责人）',
      [$field]: 'principalUser',
      rules: []
    },
    // {
    //   type: 'Input',
    //   title: '工会（分工会）主席（负责人）电话',
    //   [$field]: 'principalUserPhone',
    //   rules: ['']
    // },
    {
      type: 'Input',
      title: '上级工会组织简称',
      readOnly: true,
      [$field]: 'upShortName'
    },
    {
      type: 'Input',
      title: '上级工会主席（负责人）',
      readOnly: true,
      [$field]: 'upPrincipalUser'
    },
    {
      type: 'Input',
      title: '上上级工会组织简称',
      readOnly: true,
      [$field]: 'upUpShortName'
    },
    {
      type: 'Input',
      title: '上上级工会主席（负责人）',
      readOnly: true,
      [$field]: 'upUpPrincipalUser'
    },
    // {
    //   type: 'Input',
    //   title: '上级工会主席（负责人）电话',
    //   [$field]: 'upPrincipalUserPhone',
    //   rules: []
    // },
    {
      type: 'DatePicker',
      title: '工会成立日期',
      [$field]: 'approvalBuildingDate'
    },
    {
      type: 'RemoteSelect',
      title: '是否签署女职工专项保护协议',
      [$field]: 'orgFieldr',
      rules: [''],
      props: {
        // url: 'module/dict/outGetList',
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'KZ41',
          bizLineCode: 'YWX03',
          merge: false
        }
      }
    },
    {
      type: 'RemoteSelect',
      title: '是否建立职工之家',
      [$field]: 'orgFieldt',
      rules: [''],
      props: {
        // url: 'module/dict/outGetList',
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'KZ41',
          bizLineCode: 'YWX03',
          merge: false
        }
      }
    },
    {
      type: 'InputNumber',
      title: '职工驿站数量',
      min: 0,
      [$field]: 'orgFieldu',
      rules: [
        {
          validator (rule, value, resolve, reject) {
            if (value != null && !/^[1-9]\d*$/.test(value)) return resolve(new Error('只能输入正整数'))
            resolve()
          },
          trigger: 'change'
        }
      ]
    },
    {
      type: 'InputNumber',
      title: '建立母婴室数量',
      min: 0,
      [$field]: 'orgFieldv',
      rules: [
        {
          validator (rule, value, resolve, reject) {
            if (value != null && !/^[1-9]\d*$/.test(value)) return resolve(new Error('只能输入正整数'))
            resolve()
          },
          trigger: 'change'
        }
      ]
    },
    {
      type: 'RemoteSelect',
      title: '是否建立职工书屋',
      [$field]: 'orgFieldw',
      rules: [''],
      props: {
        url: 'api-general/module/portal/user/outGetList',
        // url: 'module/dict/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'KZ41',
          bizLineCode: 'YWX03',
          merge: false
        }
      }
    },
    {
      type: 'InputNumber',
      title: '便捷职工阅读点数量',
      min: 0,
      [$field]: 'orgFieldx',
      rules: [
        {
          validator (rule, value, resolve, reject) {
            if (value != null && !/^[1-9]\d*$/.test(value)) return resolve(new Error('只能输入正整数'))
            resolve()
          },
          trigger: 'change'
        }
      ]
    },
    {
      type: 'InputNumber',
      title: '外界授牌创新工作室数量',
      min: 0,
      [$field]: 'orgFieldz',
      rules: [
        {
          validator (rule, value, resolve, reject) {
            if (value != null && !/^[1-9]\d*$/.test(value)) return resolve(new Error('只能输入正整数'))
            resolve()
          },
          trigger: 'change'
        }
      ]
    }
  ]
}